
import React from 'react';
import { Button, Checkbox, FormControlLabel } from '@mui/material';
import { AutoTranslateToggleProps } from './types';
import { translationGlobalConfig } from './TranslationGlobalData';
import { useProxyWatch } from '../watcher';
import { useTranslation } from '../i18n';
import { Log } from '../log';

// 文件级别log
const fileLog = new Log(false, 'AutoTranslateToggle_file');
fileLog.pause = true;

/**
 * 自动翻译开关组件
 * - 可以显示为按钮或复选框
 * - 切换translationGlobalConfig.auto
 */
export function AutoTranslateToggle(props: AutoTranslateToggleProps) {
  const uiLog = fileLog.sub(false, 'AutoTranslateToggle_ui');
  uiLog.pause = true;

  const { variant = 'button', className = '' } = props;

  // 监听全局auto配置
  const [auto] = useProxyWatch(translationGlobalConfig, 'auto', translationGlobalConfig.auto);

  // 使用i18n
  const { t } = useTranslation('fanfanlo/translation/content');

  const handleToggle = () => {
    const fnLog = uiLog.sub(false, 'handleToggle_fn');
    fnLog.pause = true;

    const newAuto = !auto;
    fnLog.log('toggle auto', { from: auto, to: newAuto });
    translationGlobalConfig.auto = newAuto;
  };

  uiLog.log('render', { variant, auto });

  if (variant === 'checkbox') {
    return (
      <FormControlLabel
        className={className}
        control={
          <Checkbox
            data-testid="AutoTranslateToggle__checkbox__01JFXYZAO4O5P6Q7R8S9T0U1"
            checked={auto}
            onChange={handleToggle}
          />
        }
        label={t('AutoTranslateToggle.autoTranslate')}
      />
    );
  } else {
    return (
      <Button
        data-testid="AutoTranslateToggle__button__01JFXYZAP5P6Q7R8S9T0U1V2"
        className={className}
        variant={auto ? 'contained' : 'outlined'}
        onClick={handleToggle}
      >
        {auto ? t('AutoTranslateToggle.disableAutoTranslate') : t('AutoTranslateToggle.enableAutoTranslate')}
      </Button>
    );
  }
}
